import { render, staticRenderFns } from "./NewlyBoughtFlat.vue?vue&type=template&id=bc1be726&lang=pug&"
import script from "./NewlyBoughtFlat.vue?vue&type=script&lang=ts&"
export * from "./NewlyBoughtFlat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports